import api from '../../lib/api';
import type {
  NonconformingOutputPayload,
  PaginatedNonconformingOutputs,
  TransitionNonconformingOutputPayload,
} from './types';

export interface ListNonconformingOutputsParams {
  status?: string;
  disposition?: string;
  search?: string;
  page?: number;
  pageSize?: number;
}

export const fetchNonconformingOutputs = async (
  params: ListNonconformingOutputsParams = {},
): Promise<PaginatedNonconformingOutputs> => {
  const { data } = await api.get<PaginatedNonconformingOutputs>('nonconforming-outputs', {
    params,
  });
  return data;
};

export const createNonconformingOutput = async (payload: NonconformingOutputPayload) => {
  const { data } = await api.post('nonconforming-outputs', payload);
  return data;
};

export const updateNonconformingOutput = async (
  id: string,
  payload: Partial<NonconformingOutputPayload> & { evidenceNote?: string | null },
) => {
  const { data } = await api.put(`nonconforming-outputs/${id}`, payload);
  return data;
};

export const transitionNonconformingOutputStatus = async (
  id: string,
  payload: TransitionNonconformingOutputPayload,
) => {
  const { data } = await api.patch(`nonconforming-outputs/${id}/status`, payload);
  return data;
};

export const escalateNonconformingOutput = async (
  id: string,
  payload?: { title?: string; description?: string },
) => {
  const { data } = await api.post(`nonconforming-outputs/${id}/escalate`, payload ?? {});
  return data;
};
